"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = void 0;
var hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
exports.now = hasNativePerformanceNow
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
//# sourceMappingURL=now.js.map